import { useState } from "react";

import { css } from "@emotion/react";

import { TIMEFRAMES } from "../../types";
import SingleProgressBar from "./SingleProgressBar";
import { StatsContainerProps } from "./types";

const StatsContainer = ({ data, isLoading }: StatsContainerProps) => {
    const [hoveredPart, setHoveredPart] = useState<string | null>(null);

    const timeframes = [
        TIMEFRAMES.TaskCount7Days,
        TIMEFRAMES.TaskCount30Days,
        TIMEFRAMES.TaskCount90Days
    ];

    const handleHover = (id: string, status: boolean) =>
        setHoveredPart(status ? id : null);

    return (
        <div
            css={css({
                "& > div + div": {
                    marginTop: "16px"
                }
            })}
        >
            {timeframes.map(timeframe => (
                <SingleProgressBar
                    key={timeframe}
                    label={timeframe}
                    data={data[timeframe]}
                    isLoading={isLoading}
                    hoveredPart={hoveredPart}
                    handleHoverOn={id => handleHover(id, true)}
                    handleHoverOff={id => handleHover(id, false)}
                />
            ))}
        </div>
    );
};

export default StatsContainer;
